import { Moon, Sun, Monitor, type LucideIcon } from "lucide-react"
import { useTheme } from "../../../hooks/use-theme"
import { Button } from "../../ui/button/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu/dropdown-menu"

const icons: Record<string, LucideIcon> = { light: Sun, dark: Moon, system: Monitor }

export interface ThemeToggleLabels {
  light?: string
  dark?: string
  system?: string
  toggle?: string
}

const defaultLabels: Required<ThemeToggleLabels> = {
  light: "Light",
  dark: "Dark",
  system: "System",
  toggle: "Toggle theme",
}

export interface ThemeToggleProps {
  labels?: ThemeToggleLabels
}

export function ThemeToggle({ labels }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme()
  const l = { ...defaultLabels, ...labels }
  const Icon = icons[theme] ?? Monitor

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" aria-label={l.toggle}>
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme("light")}>
          <Sun className="mr-2 h-4 w-4" />
          {l.light}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          <Moon className="mr-2 h-4 w-4" />
          {l.dark}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")}>
          <Monitor className="mr-2 h-4 w-4" />
          {l.system}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
